import React from 'react';
import { features } from '../data/mockData';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Zap, DollarSign, LayoutDashboard, MousePointerClick, Shield, CreditCard } from 'lucide-react';

const iconMap = {
  Zap: Zap,
  DollarSign: DollarSign,
  LayoutDashboard: LayoutDashboard,
  MousePointerClick: MousePointerClick,
  Shield: Shield,
  CreditCard: CreditCard
};

const Features = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-black relative overflow-hidden">
      <div className="max-w-7xl mx-auto relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <Badge className="bg-green-600/20 text-green-400 border-green-500/30 mb-4">
            Why Us
          </Badge>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Why should you choose us?
          </h2>
          <p className="text-gray-400 text-lg max-w-3xl mx-auto">
            We offer the best service in the industry. Our team is always available to help you with any issues you may have.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature) => {
            const Icon = iconMap[feature.icon];
            return (
              <Card 
                key={feature.id}
                className="bg-gradient-to-br from-gray-900/50 to-gray-800/50 border-white/10 hover:border-purple-500/50 transition-all duration-300 group cursor-pointer"
              >
                <CardContent className="p-6">
                  <div className="w-14 h-14 bg-purple-600/20 rounded-xl flex items-center justify-center mb-4 group-hover:bg-purple-600/30 transition-colors">
                    <Icon className="text-purple-400" size={28} />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-gray-400">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* 24/7 Support Section */}
        <div className="mt-20 text-center">
          <div className="inline-block relative">
            <div className="absolute inset-0 bg-purple-600/20 blur-3xl" />
            <div className="relative bg-gradient-to-br from-purple-900/50 to-blue-900/50 border border-white/10 rounded-2xl p-12">
              <h3 className="text-6xl font-bold text-white mb-4">24/7</h3>
              <p className="text-2xl text-purple-400 font-semibold">Support</p>
            </div>
          </div>
        </div>
      </div>

      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-purple-600/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-600/10 rounded-full blur-3xl" />
    </section>
  );
};

export default Features;
